import { ListChecks, Eye, MousePointerClick } from "lucide-react";

/**
 * Wie MatchGate misst, an einer Stelle. Startseite, Zielgruppenseiten,
 * Preisseite und Demo lesen daraus, damit überall dasselbe steht.
 */

/** Die Kernaussage in einem Satz. */
export const MEASURE_CLAIM = "Jede Leistung belegt. Jede Zahl mit Herkunft.";

/** Was mit Leistungen passiert, die in keiner Vorlage stehen. */
export const CUSTOM_DELIVERABLES_TITLE = "Auch was in keiner Vorlage steht";
export const CUSTOM_DELIVERABLES =
  "Kein Sponsoring passt ganz in eine Vorlage. Was ihr darüber hinaus vereinbart, nehmt ihr beim Einrichten als eigene Leistung auf. Lässt sie sich messen, bauen wir die Messung dazu. Wo das nicht geht, wird sie eingetragen und belegt, per Foto, Dokument oder Häkchen am Spieltag. So wächst MatchGate mit jedem Sponsoring, das darüber läuft.";

/** Die drei Ebenen, nach denen jedes Dashboard aufgebaut ist. */
export const LEVELS = [
  {
    no: "1",
    icon: ListChecks,
    title: "Geliefert",
    short: "Jede vereinbarte Leistung, belegt per Foto oder Häkchen.",
    text: "Was vereinbart war und was davon erbracht ist: Bande, Durchsagen, Beiträge, Fotos. Belegt durch Foto, Häkchen am Spieltag oder automatische Prüfung.",
  },
  {
    no: "2",
    icon: Eye,
    title: "Gesehen",
    short: "Zuschauer vor Ort und Aufrufe der Partnerbeiträge.",
    text: "Wer das Engagement wahrgenommen hat: Zuschauer vor Ort, Aufrufe der Partnerbeiträge und eine offen gerechnete Hochrechnung der Kontakte.",
  },
  {
    no: "3",
    icon: MousePointerClick,
    title: "Bewirkt",
    short: "Scans, Klicks und Ergebnisse wie Bewerbungen.",
    text: "Was es ausgelöst hat: Scans, Klicks und die Ergebnisse, die das Unternehmen selbst meldet, etwa Einlösungen oder Bewerbungen.",
  },
];

/** Woher eine Zahl stammt. Wird im Dashboard an jedem Wert angezeigt. */
export const SOURCES = [
  {
    kind: "gemessen",
    text: "Von MatchGate selbst erfasst oder über die Schnittstelle eines Kanals übernommen, zum Beispiel Scans, Klicks und Aufrufe.",
  },
  {
    kind: "angabe",
    proof: true,
    text: "Von Verein oder Unternehmen eingetragen. Das Kamera-Symbol zeigt, dass ein Foto oder Dokument als Beleg vorliegt.",
  },
  {
    kind: "schaetzung",
    text: "Aus Angaben hochgerechnet. Der Rechenweg steht immer dabei, damit jede Zahl nachvollziehbar bleibt.",
  },
];
